<template>
  <div id="app">
    <router-view />

    <template v-if="!isLockout">
      <router-link tag="div" :to="{name:'Sync'}" class="band-tosync click animated fadeInUp"
                   v-show="!($router.currentRoute.name === ROUTE_NAME.sync)"
                   v-if="isOnline && (hasSendCardRequest() || hasInformationRequests())">
        Données à synchroniser
      </router-link>
      <div class="band-offline no-click animated fadeInUp" v-if="!this.isOnline">
        Mode hors ligne
      </div>
    </template>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {ROUTE_NAME} from "@/plugins/router";

export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      'hasSendCardRequest': 'Card/hasSendCardRequest',
      'hasInformationRequests': 'Info/hasInformationRequests',
      'isLockout': 'Auth/isLockout'
    }),
    /**
     * @returns {boolean}
     */
    ROUTE_NAME() {
      return ROUTE_NAME
    }
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.band-offline {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(235, 77, 75, 0.5);
  color: #fff;
  padding: 10px;
  text-align: center;
}

.band-tosync {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(235, 208, 75, 0.69);
  color: #fff;
  padding: 10px;
  text-align: center;
}
</style>
